import React from "react";
import {
  X,
  Hammer,
  Home,
  KeyRound,
  Map,
  ArrowRight,
} from "lucide-react";
import "./customermenu.css";

function CustomerMenuModal({ onClose }) {
  const menuItems = [
    {
  icon: Hammer,
  title: "Build a House",
  description: "Plan and build your dream home",
  path: "/profession/engineer",
},
    {
      icon: Home,
      title: "Buy / Sell a House",
      description: "Find or list a house for sale",
      path: "/buy-sell",
    },
    {
      icon: KeyRound,
      title: "Rent / To-Let",
      description: "Find or list a house for rent",
      path: "/rent-house",
    },
    {
      icon: Map,
      title: "Buy / Sell Land",
      description: "Explore or list land properties",
      path: "/buy-sell-land",
    },
  ];

  const handleNavigation = (path) => {
    window.location.href = path;
  };

  return (
    <div
      className="customer-menu-overlay"
      onClick={onClose}
    >
      <div
        className="customer-menu-modal"
        onClick={(e) => e.stopPropagation()}
      >

        {/* =================================================
            HEADER
        ================================================= */}

        <div className="customer-menu-header">

          <div>
            <div className="customer-menu-label">
              CIVILINK
            </div>

            <h3>
              What do you want to do?
            </h3>

            <p>
              Choose a service to get started.
            </p>
          </div>

          <button
            className="customer-menu-close"
            onClick={onClose}
            aria-label="Close menu"
          >
            <X size={18} />
          </button>

        </div>


        {/* =================================================
            OPTIONS
        ================================================= */}

        <div className="customer-menu-options">

          {menuItems.map((item) => {
            const Icon = item.icon;

            return (
              <button
                key={item.path}
                className="customer-menu-item"
                onClick={() =>
                  handleNavigation(item.path)
                }
              >

                <div className="customer-menu-icon">
                  <Icon size={21} />
                </div>

                <div className="customer-menu-content">

                  <strong>
                    {item.title}
                  </strong>

                  <span>
                    {item.description}
                  </span>

                </div>

                <div className="customer-menu-arrow">
                  <ArrowRight size={17} />
                </div>

              </button>
            );
          })}

        </div>


        {/* =================================================
            FOOTER
        ================================================= */}

        <div className="customer-menu-footer">

          <div className="customer-menu-footer-dot" />

          <span>
            Explore construction & property services
          </span>

        </div>


        <button
          className="customer-menu-cancel"
          onClick={onClose}
        >
          Close
        </button>

      </div>
    </div>
  );
}

export default CustomerMenuModal;